import NumberCard from "app/common/NumberCard";
import React, { useState } from "react";
import PhoneIphoneIcon from "../../../assets/icons/global-icon-device-sim.svg";
import VirtualLineIcon from "../../../assets/icons/global-icon-virtual-line.svg";
import WearableIcon from "../../../assets/icons/global-icon-wearable.svg";
import Confused from "../../../assets/icons/global-icon-20_Confused.svg";
import InvLoader from "../../../assets/icons/global-icon-loading.svg";
import helpIcon from "../../../assets/icons/global-icon-black-help.svg";
import iconClose from "../../../assets/icons/icon-white-close.svg";
import "./linesList.scss";
import SkeletonComp from "app/common/skeleton";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/reducers";
import Tooltip from "app/common/Tooltip";
import { failureSavingName } from "app/common/NumberCard/action";
import ModalDialog from "app/common/ModalDialog/ModalDialog";
import { ComponentsContent } from "app/common/NumberCard/NumberCardContent";
import {
  removeGranteeEmail,
  resetAttempts,
  setPairedLine,
} from "app/LineDelve/actions";
import { clearApiCallStatus } from "app/actions";
import { LineDelveTypes } from "app/LineDelve/actions/index.model";
import {
  getLineDetails,
  pairLine,
  resetLineDetails,
  unpairLine,
} from "../actions";
import { MyDigitsActionTypes } from "../actions/index.model";
import { Category } from "app/utils/categories";

export interface ModalObject {
  title: string;
  content: string;
  labelClose: string;
  closeAction: () => void;
  closeActionDisable: boolean;
  modalActionDisable: boolean;
  labelAction: string;
  isPending: boolean;
  closeBtnClass: string;
  status?: string;
  actionBtnClass: string;
}
export default function LinesList(props: any) {
  const { data, searchKey, showSkeleton, count, tabId } = props;
  const linesPayload = useSelector((state: RootState) => state.allLines);
  const dispatch = useDispatch();
  const isError = useSelector((state: RootState) => state.numberCard.isError);
  const isLongRunningQuery = useSelector(
    (state: RootState) => state.shareLine.longRunningQuery
  );
  const [open, setOpen] = React.useState(false);
  const [removePayload, setRemovePayload] = React.useState<any>();
  const content = ComponentsContent;
  const isLoading = useSelector((state: RootState) => state.lineDelve.loading);
  const [selectedPair, setSelectedPair] = React.useState("");
  const [pairedLines, setParedLines] = React.useState<any>([]);
  const selectedTab = useSelector(
    (state: RootState) => state.allLines.selectedTab
  );
  const pairDialogContent = ComponentsContent.NumberCard.sharedLines.pairLine;

  const refNoData = React.useRef() as React.MutableRefObject<HTMLInputElement>;

  const noDataClick = () => {
    if (!showSkeleton) {
      if (refNoData) {
        refNoData.current.focus();
      }
    }
  };

  React.useEffect(() => {
    if (count === 0) {
      var doc: any = document.querySelector("#nodata");
      if (doc != null) {
        doc.click();
      }
    }
  }, [count]);

  const apiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === LineDelveTypes.REMOVE_LINEDELVE_STATUS
    )
  );
  const pairApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === MyDigitsActionTypes.PAIR_LINE
    )
  );
  const unpairApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === MyDigitsActionTypes.UNPAIR_LINE
    )
  );

  const [selectedTooltip, setSelectedTooltip] = React.useState("");
  const homeContent = ComponentsContent.Home;
  const handleClose = () => {
    dispatch(failureSavingName({ isError: false }));
  };

  const [pairCBData, setPairCBData] = useState<any>(null);

  const modalClose = () => {
    setOpen(false);
    dispatch(
      clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
    );
    dispatch(resetAttempts());
  };
  const handleModalAction = () => {
    dispatch(failureSavingName({ isError: false }));
  };
  const [modelObj, setModelObj] = React.useState<ModalObject>(
    {} as ModalObject
  );

  React.useEffect(() => {
    if (!isLoading && open && !isError) {
      setOpen(false);
    }
  }, [isLoading]);

  React.useEffect(() => {
    if (selectedPair !== "") {
      setModelObj({
        ...modelObj,
        modalActionDisable: false,
      });
    }
  }, [selectedPair]);

  const handleTooltip = (tab: string) => {
    setSelectedTooltip(tab);
  };

  const handleCloseTooltip = () => {
    setSelectedTooltip("");
  };

  const handleCloseBtn = () => {
    setOpen(false);
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.PAIR_LINE }));
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.UNPAIR_LINE }));
  };

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedPair(event.target.value);
  };

  const filterPairLines = () => {
    var pairLines: any = [];
    linesPayload.lineDetails.map((obj: any) => {
      if (obj.id === Category.assignedID || obj.id === Category.unAssignedID) {
        obj.lines.map((line: any) => {
          if (
            line.LineType === "NORMAL" ||
            line.LineType === "UNKNOWN" ||
            line.LineType === "GSM"
          ) {
            pairLines.push(line);
          }
        });
      }
    });
    return pairLines;
  };

  const getDevicePairedDetails = (id: any) => {
    const pairedLines: any = filterPairLines();
    const pairedLine = pairedLines.find((line: any) => line.MSISDN === id);
    if (pairedLine) {
      return `Paired with ${pairedLine.givenName} - ${handleMSISDN(
        pairedLine.MSISDN
      )}`;
    }
    return "";
  };

  const getDeviceName = (deviceNumber: string) => {
    var deviceName = "";
    linesPayload.lineDetails.map((line) => {
      if (
        line.id === Category.assignedID ||
        line.id === Category.unAssignedID
      ) {
        line.lines.map((obj) => {
          if (obj.MSISDN === deviceNumber) {
            deviceName = obj.givenName;
          }
        });
      }
    });
    return deviceName;
  };

  const unpairCB = (data: any) => {
    setPairCBData(data);

    setModelObj({
      ...ComponentsContent.NumberCard.sharedLines.unpairLine,
      content: `${data.ganntee} will no longer be paired with ${getDeviceName(
        data.pairedDevice
      )} - ${data.pairedDevice}.`,
      status: "Unpairing...",
      closeAction: handleCloseBtn,
    });
    dispatch(setPairedLine({ msisdn: data.id }));

    setOpen(true);
  };

  const pairCB = (data: any) => {
    const filteredLines: any = filterPairLines();
    setPairCBData(data);
    setParedLines([...filteredLines]);
    setSelectedPair("");
    setModelObj({
      ...ComponentsContent.NumberCard.sharedLines.pairLine,
      content: `Select the line you want to pair with ${data.ganntee}.`,
      closeAction: handleCloseBtn,
    });
    dispatch(setPairedLine({ msisdn: data.id }));
    setOpen(true);
  };

  React.useEffect(() => {
    if (pairApiStatus?.status === "success") {
      setOpen(false);
    }

    if (pairApiStatus?.status === "already_paired") {
      let content =
        ComponentsContent.NumberCard.sharedLines.alreadyPairedLine.content;
      const replaceText =
        pairCBData.ganntee === "Unnamed"
          ? handleMSISDN(pairCBData.id)
          : pairCBData.ganntee;
      content = content.replace("$device_name", replaceText);
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.alreadyPairedLine,
        content: content.replace(
          "$pairedData",
          getDevicePairedDetails(selectedPair)
        ),
      });
    }

    if (pairApiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        title: "Unable to pair phone number",
        status: "",
        content:
          "There was an issue pairing your phone number. Would you like to try again?",
        closeAction: handleCloseBtn,
      });

      if (pairApiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          title: "Unable to pair phone number",
          status: "",
          closeAction: handleCloseBtn,
        });
      }

      setOpen(true);
    }
  }, [pairApiStatus?.noOfAttempts, pairApiStatus?.status]);

  React.useEffect(() => {
    if (unpairApiStatus?.status === "success") {
      setOpen(false);
    }
    if (unpairApiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        title: "Unable to unpair phone number",
        status: "",
        content:
          "There was an issue unpairing your phone number. Would you like to try again?",
        closeAction: handleCloseBtn,
      });

      if (unpairApiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          status: "",
          title: "Unable to unpair phone number",
          closeAction: handleCloseBtn,
        });
      }

      setOpen(true);
    }
  }, [unpairApiStatus?.noOfAttempts, unpairApiStatus?.status]);

  const pairHandler = () => {
    const contactHelp = content.NumberCard.sharedLines.contactHelp;
    if (pairApiStatus?.noOfAttempts === 3) {
      //|| (sharedLines.isAssignee && sharedLines.error)
      window.open(contactHelp, "_blank");
      handleCloseBtn();
    } else {
      let content = ComponentsContent.NumberCard.sharedLines.pairLine.content;
      const replaceText =
        pairCBData.ganntee === "Unnamed"
          ? handleMSISDN(pairCBData.id)
          : pairCBData.ganntee;
      content = content.replace("$device_name", replaceText);
      setModelObj({
        ...modelObj,
        status: "Pairing...",
        isPending: true,
        content: content.replace(
          "$pairedData",
          getDevicePairedDetails(selectedPair)
        ),
      });
      dispatch(
        pairLine({ pairedDevice: selectedPair, deviceNumber: pairCBData.id })
      );
    }
  };

  const unpairHandler = () => {
    const contactHelp = content.NumberCard.sharedLines.contactHelp;
    if (unpairApiStatus?.noOfAttempts === 3) {
      window.open(contactHelp, "_blank");
      handleCloseBtn();
    } else {
      setModelObj({
        ...modelObj,
        status: "Unpairing...",
        isPending: true,
      });
      dispatch(unpairLine({ msisdn: pairCBData.id, type: "lineDetails" }));
    }
  };

  React.useEffect(() => {
    if (apiStatus?.status === "success") {
      setOpen(false);
      dispatch(
        clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
      );
      dispatch(resetLineDetails());
      dispatch(getLineDetails());
    }
    if (apiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        content:
          "You were unable to remove this user from this line. Please wait a moment and try again.",
        closeAction: modalClose,
      });

      if (apiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          closeAction: modalClose,
        });
      }

      setOpen(true);
    }
  }, [apiStatus?.status, apiStatus?.noOfAttempts]);

  React.useEffect(() => {
    document.getElementById("help-tooltip-close")?.addEventListener("click", handleCloseTooltip);
    return () => {
      document.getElementById("help-tooltip-close")?.removeEventListener("click", handleCloseTooltip);
    };
  }, []);

  const dialogAction = (title: string) => {
    switch (title) {
      case "Unpair Device":
        return unpairHandler;
      case pairDialogContent.title:
        return pairApiStatus?.status === "already_paired"
          ? handleCloseBtn
          : pairHandler;
      case "Unable to pair phone number":
        return pairHandler;
      case "Unable to unpair phone number":
        return unpairHandler;
      case "Server Busy":
        return removeHandler;
      case "Oops, our bad":
        return removeHandler;
      case "Leave this line?":
        return removeHandler;
      default:
        return handleModalAction;
    }
  };

  const removeCB = (details: any) => {
    setRemovePayload(details);
    setModelObj({
      ...content.LineDelve.removeGuest,
      title: `Leave this line?`,
      content: `You are about to remove yourself from the line ${details.deviceName}. Are you sure you want to leave ?`,
      closeAction: () => setOpen(false),
      labelClose: "CANCEL",
      labelAction: "LEAVE",
    });

    setOpen(true);
  };

  const removeHandler = () => {
    if (apiStatus?.noOfAttempts === 3) {
      dispatch(resetAttempts());
      window.open(
        ComponentsContent.NumberCard.sharedLines.contactHelp,
        "_blank"
      );
      dispatch(
        clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
      );
      handleClose();
      setOpen(false);
    } else {
      setModelObj({
        ...modelObj,
        isPending: true,
        closeActionDisable: true,
        modalActionDisable: true,
      });
      dispatch(
        removeGranteeEmail({ ...removePayload, type: Category.lineSharedID })
      );
    }
  };

  const handleMSISDN = (msisdn: string) => {
    return msisdn.length > 10
      ? `${msisdn.slice(0, 1)}(${msisdn.slice(1, 4)}) ${msisdn.slice(
          4,
          7
        )}-${msisdn.slice(7, 11)} `
      : ``;
  };

  const SkeletonLoad = (props: any) => {
    const skeletonHeaderItems = Array.from({ length: 19 });
    return (
      <>
        {skeletonHeaderItems.map((item: any, index: number) => {
          return (
            <div key={item?.id ? index : index}>
              <SkeletonComp
                key={index}
                loadData={{
                  loading: props.showSkeleton,
                  height: 50,
                  className: `${
                    index % 5 === 0 ? "skeletonHeader" : "skeletonDetails"
                  }`,
                }}
              >
                <span></span>
              </SkeletonComp>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className="mainContainer">
      {(count > 0 || tabId !== 0) &&
        data !== undefined &&
        data.map((item: any, index: number) => {
          return (
            <div key={index}>
              {(tabId !== 0 || item?.lines?.length > 0) && (
                <div key={index}>
                  <div
                    className={`${
                      linesPayload.loading ? "header-loading" : "header"
                    }`}
                  >
                    <Tooltip
                      title={
                        <React.Fragment>
                          <span tabIndex={0}>
                            {homeContent.headerTitles[item.id - 1]}
                          </span>
                        </React.Fragment>
                      }
                      placement="top"
                      tabIndex={0}
                    >
                      {<span tabIndex={0}>{item.category}</span>}
                    </Tooltip>
                    <Tooltip
                      key={index}
                      title={
                        <React.Fragment>
                          <div className="tooltipClose" id="help-tooltip-close">
                            <img
                              src={iconClose}
                              alt={"close"}
                              width="14px"
                              height={"14px"}
                              onClick={() => handleCloseTooltip()}
                            />
                          </div>
                          {item.helpText}
                        </React.Fragment>
                      }
                      placement={"top"}
                      open={selectedTooltip === item.category}
                    >
                      <span className="help-icon">
                        <img
                          src={helpIcon}
                          alt={"help icon " + item.helpText}
                          width="16px"
                          height="16px"
                          tabIndex={0}
                          onClick={() => handleTooltip(item.category)}
                        />
                      </span>
                    </Tooltip>
                  </div>
                  {item.id === 1 && isLongRunningQuery && (
                    <div className="invLoader">
                      <span>
                        {" "}
                        <img
                          src={InvLoader}
                          alt={"InvLoader"}
                          width="24px"
                          height="24px"
                        />
                      </span>
                      <span className="yourInvitation" tabIndex={0}>
                        Your invitation is being sent
                      </span>
                    </div>
                  )}
                  <div>
                    {!showSkeleton &&
                    item.lines !== undefined &&
                    item.lines.length === 0 ? (
                      <div>
                        <>
                          {selectedTab === 0 && (
                            <div className="nodata">
                              <img
                                src={Confused}
                                alt={"ConfusedIcon"}
                                width="32px"
                                height="32px"
                              />
                              <span tabIndex={0}>
                                No results found; please try again.
                              </span>
                            </div>
                          )}
                        </>
                        <>
                          <div className="numberCardContainer">
                            <div className="deviceAvataar"></div>
                            <div className="contentContainer">
                              <div className="leftContent ">
                                {selectedTab === 1 && (
                                  <div className="nodata">
                                    <span tabIndex={0}>
                                      You do not have any eligible wearable or
                                      data paired with DIGITS lines in your
                                      account.
                                    </span>
                                    <div></div>
                                  </div>
                                )}
                                {selectedTab === 2 && (
                                  <div className="nodata">
                                    <span tabIndex={0}>
                                      You do not have any lines from your
                                      account assigned to be used on DIGITS.
                                      Please check for eligible DIGITS lines
                                      under “Unassigned” or “Shared with me”
                                      sections.
                                    </span>
                                  </div>
                                )}
                                {selectedTab === 3 && (
                                  <div className="nodata">
                                    <span tabIndex={0}>
                                      You do not have any eligible unassigned
                                      lines.
                                    </span>
                                  </div>
                                )}
                                {selectedTab === 4 && (
                                  <div className="nodata">
                                    <span tabIndex={0}>
                                      You do not have any lines shared with you.
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="divider"></div>
                            </div>
                            {/*  */}
                          </div>
                        </>
                      </div>
                    ) : (
                      item.lines.map((line: any, index: number) => {
                        return (
                          <NumberCard
                            type="lineDetails"
                            key={index}
                            deviceAvataar={
                              line.Icon === "VirtualLine"
                                ? VirtualLineIcon
                                : line.Icon === "Wearable"
                                ? WearableIcon
                                : PhoneIphoneIcon
                            }
                            deviceName={line.givenName}
                            displayNumber={handleMSISDN(line.MSISDN)}
                            id={line.MSISDN}
                            granteeID=""
                            lineType={line.LineType}
                            category={item.category}
                            categoryID={item.id}
                            searchKey={searchKey}
                            isPared={line.isPared}
                            pairedDevice={line.pairedDevice}
                            imsi={line.imsi}
                            isEditable={line.isEditable}
                            isShareble={line.isShareble}
                            removeCB={removeCB}
                            pairCB={pairCB}
                            unpairCB={unpairCB}
                            icon={line.Icon}
                          ></NumberCard>
                        );
                      })
                    )}
                    {/* {showSkeleton && (
                      <>
                        <Skeleton
                          style={{
                            width: "100%",
                            height: "50px",
                          }}
                        ></Skeleton>
                        <Skeleton
                          style={{
                            width: "100%",
                            height: "50px",
                          }}
                        ></Skeleton>
                        <Skeleton
                          style={{
                            width: "100%",
                            height: "50px",
                          }}
                        ></Skeleton>
                        <Skeleton
                          style={{
                            width: "100%",
                            height: "50px",
                          }}
                        ></Skeleton>
                      </>
                    )} */}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      {!showSkeleton && tabId === 0 && count === 0 && (
        <>
          <div
            className={`${linesPayload.loading ? "header-loading" : "header"}`}
          ></div>
          <div className="nodata">
            <img
              src={Confused}
              alt={"ConfusedIcon"}
              width="32px"
              height="32px"
            />
            <span
              ref={refNoData}
              onClick={noDataClick}
              id={"nodata"}
              tabIndex={0}
            >
              No results found; please try again.
            </span>
          </div>
        </>
      )}
      {data.length === 0 && <SkeletonLoad showSkeleton={showSkeleton} />}
      <ModalDialog
        openModal={open}
        modelObj={modelObj}
        dialogAction={dialogAction(modelObj.title)}
        // uniquId={"linesList"}
      >
        {modelObj.title === pairDialogContent.title &&
          pairApiStatus?.status !== "already_paired" && (
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-helper-label">
                Select a line to pair
              </InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={selectedPair}
                label="Select a line to pair"
                className="pairSelect"
                fullWidth
                onChange={handleChange}
              >
                {pairedLines?.map((line: any, index: any) => {
                  return (
                    <MenuItem value={line.MSISDN} key={index}>
                      <ListItemText
                        primary={line.givenName}
                        secondary={line.MSISDN}
                      ></ListItemText>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
      </ModalDialog>
    </div>
  );
}
